import { css } from 'styled-components';
import {
  grid, gridUnit,
  BreakpointQueryName,
  getSpacing, SpacingName, ThemedFunctor,
} from '@doveit/lego';

export const packageList: ThemedFunctor = ({ theme }) => css`
  ${grid(theme)}
  ${getSpacing.margin(theme, SpacingName.NEGATIVE_SMALLER)};
`;

export const packageItem: ThemedFunctor = ({ theme }) => css`
  ${gridUnit(theme, { size: { LG: 1 / 3 } })}
  ${getSpacing.padding(theme, SpacingName.SMALLER)};
`;

export const services: ThemedFunctor = ({ theme }) => css`
  ${grid(theme)}
  ${getSpacing.margin(theme, SpacingName.NEGATIVE_SMALLER)};
`;

export const servicesBlock: ThemedFunctor = ({ theme }) => css`
  ${gridUnit(theme, { size: { LG: 3 / 5 } })}
  ${getSpacing.padding(theme, SpacingName.SMALLER)};
`;

export const servicesImage: ThemedFunctor = ({ theme }) => css`
  display: none;
  ${gridUnit(theme, { size: { LG: 2 / 5 } })}

  ${theme.breakpoints.up(BreakpointQueryName.LG)} {
    display: block;
    padding: ${theme.spaceUnits.desktop.SMALLER};
  }
`;

export const servicesList: ThemedFunctor = ({ theme }) => css`
  ${grid(theme)}
  ${getSpacing.margin(theme, SpacingName.NEGATIVE_SMALL)};
`;

export const serviceItem: ThemedFunctor = ({ theme }) => css`
  ${gridUnit(theme, { size: { MD: 1 / 2 } })}
  ${getSpacing.padding(theme, SpacingName.SMALL)};
`;
